import { render, staticRenderFns } from "./ProficiencyBadge.vue?vue&type=template&id=30007cb4"
import script from "./ProficiencyBadge.vue?vue&type=script&lang=js"
export * from "./ProficiencyBadge.vue?vue&type=script&lang=js"
import style0 from "./ProficiencyBadge.vue?vue&type=style&index=0&id=30007cb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports